import config from "../../shared/config/config";
import axios from "../../shared/utils/axios";
import {
  MeetingDetailDto,
  MeetingRequest,
  SetMeetingFavoriteRequest,
  ZoomRequestDto,
  ZoomRespondDto,
  CreateOrUpdateZoomMeetingDTO,
  ResponseCreateOrUpdateZoomMeeting,
} from "../../types/meeting";

const GATEWAY_URL = config.servers.gateway.url;

interface MeetingApi {
  getMeetingList(req: {
    workgroupId: string;
    zoomDto: ZoomRequestDto;
  }): Promise<ZoomRespondDto>;
  getMeetingDetail(req: {
    workgroupId: string;
    meetingId: string;
    occurrenceId?: string;
  }): Promise<MeetingDetailDto>;
  getMeetingDetailWithDiff(req: {
    workgroupId: string;
    meetingId: string;
    occurrenceId?: string;
  }): Promise<ResponseCreateOrUpdateZoomMeeting>;
  setMeetingFavorite(
    req: SetMeetingFavoriteRequest
  ): Promise<SetMeetingFavoriteRequest>;
  getMeetingListBySearchKeyword(req: MeetingRequest): Promise<ZoomRespondDto>;
  createNewMeeting(
    workgroupId: string,
    CreateOrUpdateZoomMeetingDTO: CreateOrUpdateZoomMeetingDTO
  ): Promise<ResponseCreateOrUpdateZoomMeeting>;
  updateMeeting(
    workgroupId: string,
    meetingId: string,
    occurenceId: string,
    createOrUpdateZoomMeetingDTO: CreateOrUpdateZoomMeetingDTO
  ): Promise<ResponseCreateOrUpdateZoomMeeting>;
  deleteMeeting(
    workgroupId: string,
    meetingId: string,
    occurenceId: string
  ): Promise<ResponseCreateOrUpdateZoomMeeting>;
}

class MeetingServerApi implements MeetingApi {
  async getMeetingList(req: {
    workgroupId: string;
    zoomDto: ZoomRequestDto;
  }): Promise<ZoomRespondDto> {
    const resp = await axios.post<ZoomRespondDto>(
      `${GATEWAY_URL}/wapi/zoom/${req.workgroupId}/meetings/paging`,
      req.zoomDto
    );
    return resp.data;
  }
  async getMeetingDetail(req: {
    workgroupId: string;
    meetingId: string;
    occurrenceId?: string;
  }): Promise<MeetingDetailDto> {
    const resp = await axios.get<MeetingDetailDto>(
      req.occurrenceId
        ? `${GATEWAY_URL}/wapi/zoom/${req.workgroupId}/meetings/${req.meetingId}/detail/?occurrenceId=${req.occurrenceId}`
        : `${GATEWAY_URL}/wapi/zoom/${req.workgroupId}/meetings/${req.meetingId}/detail`
    );
    return resp.data;
  }
  async getMeetingDetailWithDiff(req: {
    workgroupId: string;
    meetingId: string;
    occurrenceId: string;
  }): Promise<ResponseCreateOrUpdateZoomMeeting> {
    const resp = await axios.get<ResponseCreateOrUpdateZoomMeeting>(
      req.occurrenceId
        ? `${GATEWAY_URL}/wapi/zoom/${req.workgroupId}/meetings/${req.meetingId}/zoomdetailWithDiff/?occurrenceId=${req.occurrenceId}`
        : `${GATEWAY_URL}/wapi/zoom/${req.workgroupId}/meetings/${req.meetingId}/zoomdetailWithDiff`
    );
    return resp.data;
  }
  async setMeetingFavorite(
    req: SetMeetingFavoriteRequest
  ): Promise<SetMeetingFavoriteRequest> {
    const resp = await axios.post<SetMeetingFavoriteRequest>(
      `${GATEWAY_URL}/wapi/zoom/favorite`,
      req
    );
    return Promise.resolve(resp.data);
  } /* zoom 회의 검색 */
  async getMeetingListBySearchKeyword(
    req: MeetingRequest
  ): Promise<ZoomRespondDto> {
    const resp = await axios.post<ZoomRespondDto>(
      `${GATEWAY_URL}/wapi/zoom/meetings/list`,
      req
    );
    return Promise.resolve(resp.data);
  }
  async createNewMeeting(
    workgroupId: string,
    CreateOrUpdateZoomMeetingDTO: CreateOrUpdateZoomMeetingDTO
  ): Promise<ResponseCreateOrUpdateZoomMeeting> {
    const resp = await axios.post<ResponseCreateOrUpdateZoomMeeting>(
      `${GATEWAY_URL}/wapi/zoom/${workgroupId}/meetings`,
      CreateOrUpdateZoomMeetingDTO
    );
    return Promise.resolve(resp.data);
  }
  async updateMeeting(
    workgroupId: string,
    meetingId: string,
    occurenceId: string,
    createOrUpdateZoomMeetingDTO: CreateOrUpdateZoomMeetingDTO
  ): Promise<ResponseCreateOrUpdateZoomMeeting> {
    let resp: any;
    // 단건 회의
    if (occurenceId === "NONE") {
      resp = await axios.post<ResponseCreateOrUpdateZoomMeeting>(
        `${GATEWAY_URL}/wapi/zoom/${workgroupId}/meetings/${meetingId}/update`,
        createOrUpdateZoomMeetingDTO
      );
    } else if (occurenceId === "ALL") {
      resp = await axios.post<ResponseCreateOrUpdateZoomMeeting>(
        `${GATEWAY_URL}/wapi/zoom/${workgroupId}/meetings/${meetingId}/update/?occurrenceId=ALL`,
        createOrUpdateZoomMeetingDTO
      );
    } else {
      resp = await axios.post<ResponseCreateOrUpdateZoomMeeting>(
        `${GATEWAY_URL}/wapi/zoom/${workgroupId}/meetings/${meetingId}/update/?occurrenceId=${occurenceId}`,
        createOrUpdateZoomMeetingDTO
      );
    }
    return Promise.resolve(resp.data);
  }
  async deleteMeeting(
    workgroupId: string,
    meetingId: string,
    occurenceId: string
  ): Promise<ResponseCreateOrUpdateZoomMeeting> {
    let resp: any;

    if (occurenceId === "NONE") {
      resp = await axios.post<ResponseCreateOrUpdateZoomMeeting>(
        `${GATEWAY_URL}/wapi/zoom/${workgroupId}/meetings/${meetingId}/delete`
      );
    } else if (occurenceId === "ALL") {
      resp = await axios.post<ResponseCreateOrUpdateZoomMeeting>(
        `${GATEWAY_URL}/wapi/zoom/${workgroupId}/meetings/${meetingId}/delete/?occurrenceId=ALL`
      );
    } else {
      resp = await axios.post<ResponseCreateOrUpdateZoomMeeting>(
        `${GATEWAY_URL}/wapi/zoom/${workgroupId}/meetings/${meetingId}/delete/?occurrenceId=${occurenceId}`
      );
    }
    return Promise.resolve(resp.data);
  }
}
const meetingApi: MeetingApi = new MeetingServerApi();
export default meetingApi;
